import Modal from "react-modal";
import "./index.css";

const customStyles = {
  overlay: {
    zIndex: 15,
    background: "rgba(0, 0, 0, 0.7)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0px",
    width: "600px",
    height: "470px",
    borderRadius: "15px",
  },
};

const FailedRowsErrModal = ({failedRows, successRows, onClose }) => {
  return (
    <>
      <Modal isOpen={failedRows.length} style={customStyles}>
        <div className="failed-row-modal-heading-container">
          <h3 className="text-base font-bold">Rows Updated: {successRows?.length}</h3>
          <h3 className="text-base font-bold">Rows with Error: {failedRows?.length}</h3>
        </div>
        <div class="fixTableHead">
          <table>
            <thead>
              <tr>
                <th>Row No.</th>
                <th>Error Message</th>
              </tr>
            </thead>

            <tbody>
              {failedRows?.map((error, index) => (
                <tr key={index}>
                  <td className="table-data-container">{error?.__uploadNumber}</td>
                  <td className="table-data-container">{error.overallValidationErrorMessage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="btn-container"> 
          <button onClick={onClose} className="btn">Close</button>
        </div>
      </Modal>
    </>
  );
};

export default FailedRowsErrModal;
